<template>

    <section v-if="responses && categories" class="textSection">
        <h1>Formation Savoir Être Aidant</h1>

        <div v-show="getUser" class="category-container">
            <p>Commencez des à présent la formation Savoir Être Aidant.
                Toutes les catégories sont présentes ici pour que vous testiez vos connaissances à l'aide des vidéos disponibles sur le site,
                veuillez les regarder au préalable avant de vous évaluer sur le sujet.
            </p>
            <nav id="navbar" class="fthematicMenuBar button-group thematics">
                <router-link :class="validCategory(category.id)" v-on:click.native="selectCategory()" :to="'/' + category.code" v-for="(category) in categoriesWithQuestionnaire" :key="category.id">
                    {{ category.name }}
                </router-link>
            </nav>
            <div class="progress-container">
                <p style="margin-top: 0">Vous pouvez tester vos connaissances directement en sélectionnant la catégorie que vous souhaitez, vous serez redirigé sur la catégorie
                avec les vidéos correspondantes et le quiz.</p>

                <p v-if="!completed"> Une fois toute les catégories complétées, vous pourrez télécharger votre certification au MOOC Savoir être Aidant.</p>

                <p v-else>Bravo ! Vous avez réussi à compléter toutes les catégories, vous pouvez télécharger votre certification
                    au MOOC Savoir être Aidant <strong class="downloadPDF" v-on:click="getNames()">ici</strong>.</p>
                <a></a>
                <div>
                    <p>Vous avez réussi {{width}}/{{categoriesWithQuestionnaire.length}} catégories !</p>
                    <div class="bar">
                        <div class="percentage has-tip"  :style="{'width': validCategories() + '%'}">
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="edit">
                <transition name="modal">
                    <div class="modal-mask">
                        <div class="modal-wrapper">
                            <div class="modal-container formation" id="formation">
                                <div class="modal-content">
                                    <h2>Informations</h2>
                                    <div class="contact-form">
                                        <form class="form-contact">
                                            <label>Nom *</label>
                                            <input type="text" v-model="nom" required="required" placeholder="Nom" />

                                            <label>Prenom *</label>
                                            <input type="text" v-model="prenom" required="required" placeholder="Prenom" />

                                            <label for="civilite">Civilité *</label>
                                            <select v-model="civilite" id="civilite" required="required">
                                                <option value="m">Homme</option>
                                                <option value="f">Femme</option>
                                            </select>
                                            <div class="valider">
                                                <button type="submit" @click="editNames()">Valider</button>
                                                <button @click="edit=false">Annuler</button>
                                            </div>
                                        </form>
                                    </div>
                                    <!--<div class="modal-footer">-->
                                        <!--<slot name="footer">-->
                                            <!--<button class="modal-default-button" @click="edit=false"></button>-->
                                        <!--</slot>-->
                                    <!--</div>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </section>
</template>
<script>
    import CategoriesService from '../services/categories.js'
    import UsersService from '../services/users.js'
    import AuthenticationService from '../services/authentication.js'

    import {mapGetters} from 'vuex'
    import Blob from 'blob'

    export default {
        name: 'formation',
        props: ['category_code'],
        data: function () {
            return {
                nom: null,
                prenom: null,
                civilite: null,
                category: null,
                user: this.$store.state.user,
                responses: null,
                categories: null,
                categoriesWithQuestionnaire: null,
                completed: false,
                width: 0,
                edit: false,
            }
        },

        created: function () {
            if (this.$store.getters.loggedIn) {
                this.token = this.$store.getters.loggedIn;
                this.setLoggedUser();
            } else {
                this.$router.replace('/')
            }
        },

        methods: {
            selectCategory: function () {
                CategoriesService.getByCode(this.$route.params.category_code).then((res) => {
                    this.category = res.body;
                }, (res) => {
                    console.warn(res)
                })
            },
            // Get categories on loading
            getCategoriesList: function () {
                CategoriesService.get().then((res) => {
                    this.categories = res.body;
                    this.getCategoriesWithQuestionnaire();
                }, (res) => {
                    console.warn(res)
                })
            },

            getCategoriesWithQuestionnaire: function() {
                this.categoriesWithQuestionnaire = this.categories.filter(category => category.hasQuestionnaire == true);
                console.log(this.categoriesWithQuestionnaire);
            },

            // Get user completed categories on loading
            getResponses: function (id) {
                CategoriesService.getResponses(id).then((res) => {
                    this.responses = res.body;
                }, (res) => {
                    console.warn(res)
                })
            },
            // Change links color on completed categories
            validCategory: function (id) {
                let result = [];
                this.responses.forEach(r => {
                    if (r.category_id === id && r.answer_id === 1)
                        result.push('success')
                });
                result.length === 0 ? result.push('none') : {};
                return result;
            },
            // Change progress bar based on user results
            validCategories: function () {
                let width = 0;
                this.responses.forEach(function (r) {
                    r.answer_id === 1 ? width++ : {};
                });
                this.width = width;
                this.width === this.categoriesWithQuestionnaire.length ? this.completed = true : {};
                return (100 / this.categoriesWithQuestionnaire.length) * width;
            },
            // Request diploma pdf with user informations and open it
            getNames: function () {
                // Get user data for pdf generation
                UsersService.getNames(this.token).then(
                    (res) => {
                        this.nom = res.data['nom'];
                        this.prenom = res.data['prenom'];
                        this.civilite = res.data['civilite'];
                        // Check if user informations are valid, if not open modal to edit them
                        if(!this.nom || !this.prenom || !this.civilite) {
                            this.edit = true;
                            return;
                        }
                        this.sendPdf();
                    }, (res) => {
                        console.warn(res);
                    }
                );
            },
    // Generate pdf and get it
            sendPdf: function() {
                UsersService.sendPdf({
                    nom: this.nom,
                    prenom: this.prenom,
                    civilite: this.civilite,
                }).then((res) => {
                    const blob = new Blob([res.data], {type: 'application/pdf'});
                    const fileURL = window.URL.createObjectURL(blob);
                    if (window.navigator.msSaveOrOpenBlob){
                        window.navigator.msSaveBlob(blob, 'diploma.pdf');
                    } else {
                        const fileLink = document.createElement('a');
                        document.body.appendChild(fileLink);
                        fileLink.href = fileURL;
                        window.open(fileURL)
                    }
                }, (res) => {
                    console.warn(res);
                });
            },

            // Edit user informations
            editNames: function() {
                if (!this.nom || !this.prenom || !this.civilite) return;

                UsersService.editNames({
                    id: this.user.id,
                    nom: this.nom,
                    prenom: this.prenom,
                    civilite: this.civilite
                }).then((res) => {
                    this.edit = false;
                    }, (error) => {
                    console.warn(error);
                    }
                );
            },

            setLoggedUser: function () {
                AuthenticationService.getUserByToken({
                    token: this.token
                }).then((res) => {
                    this.user = res.body[0];
                    this.$store.commit('setUser', this.user);
                    this.getResponses({user_id: this.user.id});
                    this.getCategoriesList();
                }, (res) => {
                    console.log(res);
                });
            },
        },
        mounted: function() {
        },
        computed: {
            ...mapGetters(['getUser'])
        }
    }
</script>
<style scoped>

    .category-container {
        display: inline-block;
    }

    .nav-container {
        display: inline-block;
        width: 100%;
    }

    .progress-container {
        display: flex;
        flex-direction: column;
        width: 50%;
        height: 355px;
        justify-content: space-between;
    }

    .bar {
        width: 100%;
        height: 2em;
        border-radius: 1em;
        position: relative;
        box-shadow: inset 0 0 0 1px rgba(0,0,0,0.1);
        display: inline-block;
        margin-top: 10px;
    }

    .bar .percentage {
        position: relative;
        font-size: 2em;
        background-image: linear-gradient(to right, #103479, #009fe3 300px);
        height: 1em;
        border-radius: 0.5em;
    }

    .fthematicMenuBar {
        background-color: white;
        color: black;
        font-weight: bolder;
        flex-direction: column;
        justify-content: space-between;
        display: flex;
        width: 260px;
        float: left;
        position: relative;
        z-index: 2;
        padding-right: 30px;
    }

    .fthematicMenuBar .none, .success {
        max-width: 260px;
        min-width: 12%;
        padding-left: 3px;
        padding-top: 10px;
        padding-bottom: 10px;
        margin-bottom: 20px;
        border: 1px solid black;
        font-family: 'quicksandbold', Arial, sans-serif;
        font-size: 1.1em;
        text-decoration: none;
        cursor: pointer;
        transition: 0.6s;
    }

    .fthematicMenuBar .none {
        background-color: gray;
    }

    .fthematicMenuBar a:nth-child(1):hover,
    .fthematicMenuBar a:nth-child(1).router-link-active,
    .fthematicMenuBar a:nth-child(1).success {
        background-color: #103479;
    }

    .fthematicMenuBar a:nth-child(2):hover,
    .fthematicMenuBar a:nth-child(2).router-link-active,
    .fthematicMenuBar a:nth-child(2).success {
        background-color: #05458A;
    }

    .fthematicMenuBar a:nth-child(3):hover,
    .fthematicMenuBar a:nth-child(3).router-link-active,
    .fthematicMenuBar a:nth-child(3).success {
        background-color: #00579b;
    }

    .fthematicMenuBar a:nth-child(4):hover,
    .fthematicMenuBar a:nth-child(4).router-link-active,
    .fthematicMenuBar a:nth-child(4).success {
        background-color: #0065AB;
    }

    .fthematicMenuBar a:nth-child(5):hover,
    .fthematicMenuBar a:nth-child(5).router-link-active,
    .fthematicMenuBar a:nth-child(5).success {
        background-color: #0073bc;
    }

    .fthematicMenuBar a:nth-child(6):hover,
    .fthematicMenuBar a:nth-child(6).router-link-active,
    .fthematicMenuBar a:nth-child(6).success {
        background-color: #0089cF;
    }

    .fthematicMenuBar a:nth-child(7):hover,
    .fthematicMenuBar a:nth-child(7).router-link-active,
    .fthematicMenuBar a:nth-child(7).success {
        background-color: #009fe3;
    }

    .fthematicMenuBar a:last-child {
        margin-bottom: 0px;
    }

    .fthematicMenuBar a:hover,
    .categories.router-link-active {
        color: black;
    }

    .router-link-active {
        color: black;
    }

    .fthematicMenuBar a:active {
        background-color: #8ad4f4;
    }

    fieldset {
        border:none;
        border-top: 1px solid black;
        margin:10px;
    }

    .modal-container{
        min-height:10%;
    }

    .modal-container.formation
    {
        overflow-x: hidden;
        overflow-y: auto;
        background-color: #e5ebf7;
        padding: 0;
        border-radius: 17px;
        margin-top: 15%;
    }

    .modal-default-button {
        right: 14%;
        top: 25%;
        height: 34px;
        width: 33px;
    }

    .formation .modal-body
    {
        width:80%;
    }

    .formation .valider{
        margin-top: 10%;
        text-align: center;
    }
    .formation .valider button,
    .formation .valider a {
        background-color: #103479;
        border-radius: 25px;
        border: none;
        color: white;
        text-decoration: none;
        padding: 15px 32px;
        font-size: 16px;
    }

    /* The Modal (background) */
    .formation .modal {
        display: none; /* Hidden by default */
        position: fixed; /* Stay in place */
        z-index: 1; /* Sit on top */
        padding-top: 100px; /* Location of the box */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: #e5ebf7; /* Fallback color */
        background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
    }

    /* Modal Content */
    .formation .modal-content {
        border-radius: 25px;
        background-color: #e5ebf7;
        margin: auto;
        padding: 20px;
        width: 80%;
    }

    .contact-form {
        width: 100%;
        display: inline-block;
        margin: auto;
        text-align: start;
    }

    form {
        border-radius: 4px;
        padding: 15px;
        width: 35%;
        margin: auto;
    }

    input {
        margin-top: 5px;
        margin-bottom: 10px;
        width: 90%;
        padding: 10px 5px;
        background-color: #fafafa;
        border-radius: 2px;
        font-size: 16px;
        box-shadow: inset 0 1px 2px rgba(0, 0, 0, .4);
        resize: none;
        display: block;
    }

    .valider button {
        color: #fff;
        background-color: #0f3274;
        padding: 10px 12px;
        border: none;
        border-radius: 3px;
        cursor: pointer;
    }

    .downloadPDF {
        cursor: pointer;
    }

    .downloadPDF:hover {
        text-decoration: underline;
        color: #00579b;
    }

</style>


// WEBPACK FOOTER //
// Formation.vue?65740924